import { render, staticRenderFns } from "./YourEnquiries.vue?vue&type=template&id=29e8551e&scoped=true&"
import script from "./YourEnquiries.vue?vue&type=script&lang=js&"
export * from "./YourEnquiries.vue?vue&type=script&lang=js&"
import style0 from "./YourEnquiries.vue?vue&type=style&index=0&id=29e8551e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e8551e",
  null
  
)

export default component.exports